import actions from '../../actionTypes';

export default category => {
  return {
    type: actions.ADD_CATEGORY,
    category
  };
};



// WEBPACK FOOTER //
// ./src/reducers/categories/actions/addCategories.js